// extracted by mini-css-extract-plugin
export default {"searchPop":"SearchUser_searchPop__Dwgnz","people":"SearchUser_people__IO5VZ","peopleScroll":"SearchUser_peopleScroll__xRk8s","user":"SearchUser_user__bFpBP"};